var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    attrs: {
      "color": "transparent"
    }
  }, [_c('lecture-main-list-title', _vm._b({}, 'lecture-main-list-title', {
    title: _vm.title,
    route: _vm.route
  }, false)), _c('v-row', [_vm._l(_vm.items, function (value) {
    return [_c('v-col', {
      key: value._id,
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('lecture-list-card', _vm._b({}, 'lecture-list-card', {
      value
    }, false))], 1)];
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }